import React from 'react';
import Layout from './components/Layout.js';
import Home from './components/Home.js';
import Experience from './components/Experience.js';
import Projects from './components/Projects.js';
import Education from './components/Education.js';
import Technical from './components/Technical.js';
import Involvements from './components/Involvement.js';
import Interests from './components/Interests.js';
import Contact from './components/Contact.js';

function App() {
  return (
    <Layout>
      <Home />
      <Experience />
      <Projects />
      <Education />
      <Technical />
      <Involvements />
      <Interests />
      <Contact />
    </Layout>
  );
}

export default App;
